export default "https://fenwan.cdn.bcebos.com/gamecenter/static/game/assets/imgs/download-shop-drawer-bg.05fe35c2.png";